import React from 'react';
import { Reveal } from './ui/Reveal';
import { Activity, Heart, UtensilsCrossed, Gift } from 'lucide-react';
const benefits = [{
  icon: Activity,
  title: 'Controla tus niveles',
  description: 'Aprende a estabilizar tu azúcar en sangre y mejorar tus niveles de colesterol de forma natural con alimentación inteligente.'
}, {
  icon: Heart,
  title: 'Reduce riesgos',
  description: 'Fortalece tu sistema inmunológico y disminuye las probabilidades de desarrollar enfermedades metabólicas a largo plazo.'
}, {
  icon: UtensilsCrossed,
  title: 'Sin pasar hambre',
  description: 'Olvídate de las porciones minúsculas. Descubre cómo nutrirte adecuadamente sin sentirte privada ni realizar ejercicios extremos.'
}, {
  icon: Gift,
  title: 'Bonos y Garantía',
  description: 'Accede a recetarios exclusivos, actualizaciones de por vida y una garantía total de satisfacción de 7 días.'
}];
export function Benefits() {
  return <section className="py-24 bg-brand-sand" data-id="element-31">
      <div className="max-w-6xl mx-auto px-6" data-id="element-32">
        <Reveal data-id="element-33">
          <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-34">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-35">
              Una transformación integral
            </h2>
            <p className="text-lg text-gray-600" data-id="element-36">
              Este no es solo un programa de pérdida de peso, es un manual para
              recuperar tu vitalidad y bienestar.
            </p>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-37">
          {benefits.map((benefit, index) => <Reveal key={index} delay={index * 0.1} data-id="element-38">
              <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow h-full border border-gray-100" data-id="element-39">
                <div className="w-14 h-14 bg-brand-sage/20 rounded-xl flex items-center justify-center mb-6" data-id="element-40">
                  <benefit.icon className="w-7 h-7 text-brand-forest" data-id="element-41" />
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-42">{benefit.title}</h3>
                <p className="text-gray-600 leading-relaxed text-sm" data-id="element-43">
                  {benefit.description}
                </p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}